import {
  MAutocomplete,
  MDatePicker,
  ResponsiveFormContainer,
} from "@app/components";
import useFilteredProcedures from "@app/pages/samples/hook/useFilteredProcedures";
import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import {
  useEquipment,
  useEquipmentMide,
  useTypesUnits,
  useUser,
} from "@services/servicesGenericsTables";
import React from "react";
import { useFormContext } from "react-hook-form";
import { OPTIONS_YES_NO } from "../iodo131/utils/constants";

const CountingDP = () => {
  const form = useFormContext();
  const { userList } = useUser();
  const { equipmentList } = useEquipment();
  const { currentCounting } = useAnalysis();
  const filteredProcedures = useFilteredProcedures("CON");
  const { loading } = useEquipmentMide();
  const { typesUnitsis } = useTypesUnits();

  const watchNoiseBack1mc = form.watch("noise_back_1mc");

  return (
    <>
      {currentCounting.index !== undefined ? (
        <React.Fragment key={currentCounting.id}>
          <ResponsiveFormContainer columns={5}>
            <MAutocomplete
              name="counting_analyst"
              options={userList}
              label="Seleccione un analista"
              getOptionLabel={(option) => option.username || ""}
              validation={{ required: "El analista es requerido" }}
              disabled={!currentCounting.canEdit}
            />

            <MAutocomplete
              name="counting_procedure"
              options={filteredProcedures}
              label="Procedimiento MLPMA"
              getOptionLabel={(option) => `${option.numop}` || ""}
              validation={{
                required:
                  filteredProcedures?.length > 0
                    ? "La parte es requerida"
                    : false,
              }}
              disabled={!currentCounting.canEdit}
            />

            <MAutocomplete
              key={`counting_equipment-${form.getValues("counting_equipment")}`}
              name="counting_equipment"
              options={equipmentList}
              label="Seleccione un Equipo"
              getOptionLabel={(option) =>
                `${option.codigo} - ${option.descripcion}` || ""
              }
              validation={{ required: "El equipo es requerido" }}
              multiple
              loading={loading}
              disabled={!currentCounting.canEdit}
            />

            <MDatePicker
              key="counting_date"
              name="counting_date"
              pickerType="date"
              label="Fecha de lectura"
              validation={{
                required: "La Fecha de lectura es requerida",
              }}
              disabled={!currentCounting.canEdit}
            />

            <MAutocomplete
              key={JSON.stringify(form.getValues("counting_unit_types"))}
              name="counting_unit_types"
              options={typesUnitsis}
              label="Seleccione un tipo de unidad"
              getOptionLabel={(option) =>
                `${option.codigo} | ${option.descripcion}`
              }
              validation={{ required: "El tipo de unidad es requerido" }}
              disabled={!currentCounting.canEdit}
            />

            <MAutocomplete
              key={JSON.stringify(form.getValues("noise_back_1mc"))}
              name="noise_back_1mc"
              options={OPTIONS_YES_NO}
              label="¿El ruido de fondo es <1mC?"
              getOptionLabel={(option) => option.label}
              validation={{
                required:
                  "La respuesta a la coloración violeta en la fase orgánica es requerida",
              }}
              disabled={!currentCounting.canEdit}
              stylesInput={
                watchNoiseBack1mc?.value === 0
                  ? { backgroundColor: "#ef233c" }
                  : watchNoiseBack1mc?.value === 1
                  ? { backgroundColor: "#a7c957" }
                  : undefined
              }
            />
          </ResponsiveFormContainer>
        </React.Fragment>
      ) : null}
    </>
  );
};

export default CountingDP;
